import { render, staticRenderFns } from "./WaterConsumptionPage.vue?vue&type=template&id=146139a1&scoped=true&"
import script from "./WaterConsumptionPage.vue?vue&type=script&lang=js&"
export * from "./WaterConsumptionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146139a1",
  null
  
)

export default component.exports